import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { usePassProducts } from '../../../hooks/passes/usePassProducts'

import Icon from '../../../components/ui/Icon'
import Loading from '../../../components/loading/Loading'
import { Button } from '../../../components/buttons/Button'
import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { PassProductCard } from '../../../components/authenticated/passes/passProductCard/PassProductCard'

import { PassProduct } from '../../../types/booking/booking'

/** Passes on sale, for visitors: buying one needs an account (minutes belong to a customer). */
const GuestMemberships = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('passes')
  const { list } = usePassProducts()
  const [products, setProducts] = useState<PassProduct[] | null>(null)

  useEffect(() => {
    list()
      .then(result => setProducts(result ?? []))
      .catch(() => setProducts([]))
  }, [list])

  return (
    <div className="guest-memberships">
      <PageHeader
        title={{ eyebrow: t('passes.guest.eyebrow'), h1: t('passes.guest.title') }}
        sub={t('passes.guest.sub')}
      />
      {products === null ? (
        <Loading variant="inline" />
      ) : products.length === 0 ? (
        <div className="empty muted">{t('passes.none-on-sale')}</div>
      ) : (
        <div className="row g-3">
          {products.map(product => (
            <div className="col-12 col-md-6 col-xxl-4" key={product.id}>
              <PassProductCard
                product={product}
                actionLabel={t('passes.guest.sign-in-to-buy')}
                onAction={() => navigate('/register')}
              />
            </div>
          ))}
        </div>
      )}

      <section className="guest-memberships-pay">
        <p className="guest-memberships-pay-text">{t('passes.guest.pay-line')}</p>
        <Button
          className="guest-memberships-pay-btn"
          label={t('passes.guest.pay-cta')}
          icon={<Icon name="arrowR" size={16} />}
          iconPosition="right"
          variant="primary"
          size="lg"
          onClick={() => navigate('/guest-booking')}
        />
      </section>
    </div>
  )
}

export default GuestMemberships
